(() => {
  const imageCache = new Map();
  const imageFor = (url) => {
    if (!imageCache.has(url)) imageCache.set(url, fetch(url + '.js').then(r => r.ok ? r.json() : null).catch(() => null));
    return imageCache.get(url);
  };
  const enhance = () => {
    document.querySelectorAll('.jdgm-testimonials-carousel:not([data-frida-warm])').forEach(widget => {
      const originals = Array.from(widget.querySelectorAll('.jdgm-card[data-review-id]'));
      if (!originals.length) return;
      widget.dataset.fridaWarm = 'true';
      const heading = widget.querySelector('.jdgm-title');
      if (heading) {
        const words = heading.textContent.split(',');
        heading.replaceChildren();
        words.forEach((word, i) => {
          const line = document.createElement('span');
          line.textContent = word.trim() + (i === 0 && words.length > 1 ? ',' : '');
          heading.append(line);
        });
      }
      const intro = document.createElement('p');
      intro.className = 'frida-reviews-intro';
      intro.textContent = 'Piccole emozioni da indossare. Raccontate da voi.';
      heading?.after(intro);
      const track = document.createElement('div');
      track.className = 'frida-reviews-track';
      track.setAttribute('role', 'list');
      track.setAttribute('aria-label', 'Le recensioni delle clienti');
      originals.forEach(original => {
        const card = document.createElement('article');
        card.className = 'frida-reviews-card';
        card.setAttribute('role', 'listitem');
        const content = original.querySelector('.jdgm-card-content').cloneNode(true);
        const quote = content.querySelector('.jdgm-quote-marks');
        quote?.remove();
        card.append(content);
        const product = content.querySelector('.jdgm-product-name a');
        if (product) {
          const path = new URL(product.href, location.origin).pathname;
          const photoLink = document.createElement('a');
          photoLink.className = 'frida-reviews-photo';
          photoLink.href = path;
          photoLink.setAttribute('aria-label', product.textContent.trim());
          card.prepend(photoLink);
          imageFor(path).then(data => {
            if (!data?.featured_image) { photoLink.remove(); return; }
            const photo = document.createElement('img');
            const url = new URL(data.featured_image, location.origin);
            url.searchParams.set('width', '240');
            photo.src = url.href;
            photo.alt = product.textContent.trim();
            photo.width = 120;
            photo.height = 120;
            photo.loading = 'lazy';
            photoLink.append(photo);
          });
        }
        track.append(card);
      });
      const fitMobileCard = () => {
        if (!matchMedia('(max-width: 749px)').matches) { track.style.height = ''; return; }
        const step = track.firstElementChild.getBoundingClientRect().width + 24;
        const current = track.children[Math.min(track.children.length - 1, Math.round(track.scrollLeft / step))];
        track.style.height = (current.offsetHeight + 24) + 'px';
      };
      track.addEventListener('scroll', fitMobileCard, {passive: true});
      window.addEventListener('resize', fitMobileCard);
      const controls = document.createElement('div');
      controls.className = 'frida-reviews-controls';
      [-1, 1].forEach(direction => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', direction < 0 ? 'Recensioni precedenti' : 'Recensioni successive');
        button.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        if (direction < 0) button.className = 'frida-reviews-prev';
        button.addEventListener('click', () => track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
        controls.append(button);
      });
      const originalContent = widget.querySelector('.jdgm-content');
      originalContent.hidden = true;
      originalContent.setAttribute('aria-hidden', 'true');
      originalContent.inert = true;
      widget.append(track, controls);
      requestAnimationFrame(fitMobileCard);
    });
  };
  enhance();
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  });
  observer.observe(document.body, {childList: true, subtree: true});
})();
